import dialogSkin from "../common/dialog.skin";

const formDialog = {
  ...dialogSkin,
  "full-page-title": {
    background: "var(--gc-dark-background)",
    color: "var(--gc-dark-background-text-color)",
    width: "100%",
    padding: "5px 10px",
    "text-align": "left",
  },
};

export default formDialog;
